import { render, staticRenderFns } from "./DynamicTextInfo.vue?vue&type=template&id=069c4514&scoped=true&"
import script from "./DynamicTextInfo.vue?vue&type=script&lang=js&"
export * from "./DynamicTextInfo.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTextInfo.vue?vue&type=style&index=0&id=069c4514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c4514",
  null
  
)

export default component.exports